import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

export default class CopyLinkToClipboard extends Base {
  static config = {
    name: 'CopyLinkToClipboard',
    log: true,
  };

  onClick() {
    const url = new URL(window.location.href);
    url.hash = this.$el.parentElement.id;
    navigator.clipboard.writeText(url.toString())
    .then(() => {
        addClass(this.$el, '!tw-bg-green !tw-text-white');
        setTimeout(() => {
          removeClass(this.$el, '!tw-bg-green !tw-text-white');
        }, 600);
      })
      .catch(err => {
        this.$log('Erreur lors de la copie:', err);
      });
  }
}
